import { useFeatureIsOn } from '@growthbook/growthbook-react';

/**
 * Apple sign-in / sign-up rolls out behind the GrowthBook gate
 * "apple-sign-in" (same pattern as "google-sign-in") and additionally needs a
 * Services ID configured (`appleClientId`) — Sign in with Apple JS cannot start
 * without one, so the button stays hidden rather than failing on click.
 */
const useAppleAuthEnabled = (): boolean => {
  const flagOn = useFeatureIsOn('apple-sign-in');
  return flagOn && Boolean(CONFIG.appleClientId);
};

export default useAppleAuthEnabled;
